import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { camelize } from 'humps'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import {
  questionsLoadedSelector, selectNextUrl, selectNextImages, selectBrowser
} from './selectors'
import { fetchQuestions } from './actions'
import styles from './tasteprofileonboarding.css'

export class TasteProfileOnboarding extends Component {
  componentDidMount () {
    if (!this.props.questionsLoaded) {
      this.props.getQuestions()
    }
  }

  render () {
    const {children, nextUrl, location} = this.props
    // We always want to give a next url to our children. This can be both a next question or a
    // result page.
    const styleName = camelize(location.pathname.split('/').slice(-1)[0])
    return (
      <div className={classnames(styles.background, styles[styleName])}>
        {React.cloneElement(children, {nextUrl})}
      </div>
    )
  }
}

TasteProfileOnboarding.propTypes = {
  questionsLoaded: PropTypes.bool.isRequired,
  getQuestions: PropTypes.func.isRequired,
  children: PropTypes.object,
  nextUrl: PropTypes.string.isRequired,
  nextImages: PropTypes.array.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  browser: PropTypes.object.isRequired
}

TasteProfileOnboarding.defaultProps = {
  children: {},
  nextImages: []
}

const mapStateToProps = createStructuredSelector({
  questionsLoaded: questionsLoadedSelector,
  nextUrl: selectNextUrl,
  browser: selectBrowser,
  nextImages: selectNextImages
})

const mapDispatchToProps = (dispatch) => ({
  getQuestions: () => dispatch(fetchQuestions())
})

export default connect(mapStateToProps, mapDispatchToProps)(TasteProfileOnboarding)
